import { apiClient } from "helpers/api_helper";

export const getBillSettingById = async (data: object, id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/sales/GetAllBillSettingByStoreId?StoreId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};